import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-with-loader',
  templateUrl: './with-loader.component.html',
  styleUrls: ['./with-loader.component.css']
})
export class WithLoaderComponent implements OnInit {
  @Input() isLoading:boolean;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/with-loader/with-loader.component.ts